/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState} from 'react'
import 'react-calendar/dist/Calendar.css'
import FormsDocuments from '../components/FormsDocuments'
import triangle from '../images/triangledark.png'
import Zoom from './ZoomComponent'
import GoogleZoom from '../components/GoogleZoom'
import DriverHistory from './DriverHistory'
import DvlaHistory from './DvlaHistory'
import OldDocuments from './OldDocuments'
import Embeded from './documents/Embeded'

var numberKeeper = 0

const Documents = (props) => {
    var CryptoJS = require("crypto-js");
    const [  valueForSubmit, setValueForSubmit ] = useState('')
    const [ imageArray, setImageArray ] = useState([])
    const [ submitFilesDivSelection, setSubmitFilesDivSelection ] = useState(false)
    const [ buttonText, setButtonText ] = useState('Add Document')
    const [ classForDiv, setClassForDiv ] = useState('submit_files')
    const [ highlightedPicture, setHighlightedPicture ] = useState(null)
    const [ highlightedImageDetails, setHighlitedImageDetails ] = useState(null)
    const [ currentId, setCurrentId ] = useState(0)
    const [ addImageSelected, setAddImageSelected ] = useState(false)
    const [ handlePdfUrl, setHandlePdfUrl ] = useState('')
    const [ highlightedPictureGate, setHighlightedPictureGate ] = useState(false)
    const [ loadingScreen, setLoadingScreen ] = useState(null)
    const [ currentPageNumber, setCurrentPageNumber ] = useState(1)
    const [ localPercent, setLocalPercent ] = useState(0)
    const [ percentGate, setPercentGate ] = useState(false)
    const [ numberOfDocuments, setNumberOfDocuments ] = useState(0)
    const [ selectedDriver, setSelectedDriver ] = useState(null)
    const [ deletedImageId, setDeletedImageId ] = useState(0)
    const [quickViewBool, setQuickViewBool] = useState(true)
    const [content, setContent] = useState(null)

    const handleMakingMainImage = (e, source, fullSource, id) => {
        // let newImage = source.replace(/https:\/\/res\.cloudinary\.com\/shanklandium\/image\/upload\//, 'https://res.cloudinary.com/shanklandium/image/upload/w_600,h_700/')
        setClassForDiv('submit_files_dissapear')
        setButtonText('Add Document')
        setTimeout( () => {
            setSubmitFilesDivSelection(false)
            setClassForDiv('submit_files')
        }, 1000)
        setCurrentId(id)
        setHighlitedImageDetails(fullSource)
        setHighlightedPicture(
            <GoogleZoom
                img={source}
            />
        )
        setHandlePdfUrl(source)
        setHighlightedPictureGate(true)
    }

    // map props to state
    useEffect( () => {
        setSelectedDriver(props.selectedDriver)
    }, [props.selectedDriver])

    useEffect( () => {
        let localCounter = 0
        let ImageArray = []
        if (props.selectedDriver.imgArray) {
            let localBool = false

            let dvlaArray = []
            if (props.superUser || props.email === 'compliance@h2ologistics.co.uk' || props.email === 'Compliance@h2ologistics.co.uk' || props.email === 'i.stoykov@h2ologistics.co.uk'|| props.email === 'Compliance@h2ologistics.co.uk') {

                let namesListArray = [
                    'Bank Details',
                    'Birth Certificate',
                    'Visa',
                ]

                props.selectedDriver.imgArray.forEach( (ele, id) => {
                    if (!ele.storageBool) {
                        if (ele.name === 'DVLA Check') {
                            dvlaArray.push(ele)
                        } else {
                            localCounter++
                            if (!ele.imagesLink.includes('.pdf')) {
                                // dvla logic
                                if (ele.name === 'DVLA Check') {
                                    if (localBool) {
            
                                    } else {
                                        localBool = true
                                        if (ele.verified === 'True') {
                                            ImageArray.push (
                                                <div className='image_list_divs_true' onClick={(e, source) => handleMakingMainImage(e, ele.imagesLink, ele, id)}>
                                                    <h3>{ele.name}</h3>
                                                    <h4 className='labelsOnPhoto'>{ele.managerApprovedName}</h4>
                                                    <h4 className='labelsOnPhoto'>{new Date(ele.managerApprovedDate).toLocaleDateString('en-GB')}</h4>
                                                    <img src={ele.imagesLink} loading="lazy" alt='cannot view' className='uploaded_image_two_true' />
                                                </div>
                                            )
                                        } else if (ele.verified === 'False') {
                                            ImageArray.push (
                                                <div className='image_list_divs_falseY' onClick={(e, source) => handleMakingMainImage(e, ele.imagesLink, ele, id)}>
                                                    <h3>{ele.name}</h3>
                                                    <h4 className='labelsOnPhoto'>{ele.managerApprovedName}</h4>
                                                    <h4 className='labelsOnPhoto'>{new Date(ele.managerApprovedDate).toLocaleDateString('en-GB')}</h4>
                                                    <img src={ele.imagesLink} loading="lazy" alt='cannot view' className='uploaded_image_two_true' />
                                                </div>
                                            )
                                        } else {
                                            ImageArray.push (
                                                <div className='image_list_divs_false' onClick={(e, source) => handleMakingMainImage(e, ele.imagesLink, ele, id)}>
                                                    <h3>{ele.name}</h3>
                                                    <h4 className='labelsOnPhoto'>{ele.managerApprovedName}</h4>
                                                    <img src={ele.imagesLink} loading="lazy" alt='cannot view' className='uploaded_image_two_false' />
                                                </div>
                                            )
                                        }
                                    }
                                } else {
                                    if (ele.verified === 'True') {
                                        ImageArray.push (
                                            <div className='image_list_divs_true' onClick={(e, source) => handleMakingMainImage(e, ele.imagesLink, ele, id)}>
                                                <h3>{ele.name}</h3>
                                                <h4 className='labelsOnPhoto'>{ele.managerApprovedName}</h4>
                                                <h4 className='labelsOnPhoto'>{new Date(ele.managerApprovedDate).toLocaleDateString('en-GB')}</h4>
                                                <img src={ele.imagesLink} loading="lazy" alt='cannot view' className='uploaded_image_two_true' />
                                            </div>
                                        )
                                    } else if (ele.verified === 'False') {
                                        ImageArray.push (
                                            <div className='image_list_divs_falseY' onClick={(e, source) => handleMakingMainImage(e, ele.imagesLink, ele, id)}>
                                                <h3>{ele.name}</h3>
                                                <h4 className='labelsOnPhoto'>{ele.managerApprovedName}</h4>
                                                <h4 className='labelsOnPhoto'>{new Date(ele.managerApprovedDate).toLocaleDateString('en-GB')}</h4>
                                                <img src={ele.imagesLink} loading="lazy" alt='cannot view' className='uploaded_image_two_true' />
                                            </div>
                                        )
                                    } else {
                                        ImageArray.push (
                                            <div className='image_list_divs_false' onClick={(e, source) => handleMakingMainImage(e, ele.imagesLink, ele, id)}>
                                                <h3>{ele.name}</h3>
                                                <h4 className='labelsOnPhoto'>{ele.managerApprovedName}</h4>
                                                {/* <h4 className='labelsOnPhoto'>{new Date(ele.managerApprovedDate).toLocaleDateString('en-GB')}</h4> */}
                                                <img src={ele.imagesLink} loading="lazy" alt='cannot view' className='uploaded_image_two_false' />
                                            </div>
                                        )
                                    }
                                }
                            } else {
                                // dvla logic
                                if (ele.name === 'DVLA Check') {
                                    localBool = true
                                    if (localBool) {
            
                                    } else {
                                        let pageString = 'pg_1/'
                                        let begginingOfUrl = ele.imagesLink.slice(0, 53)
                                        let endOfUrlUrl = ele.imagesLink.slice(53)
                                        let endUrlString = begginingOfUrl.concat(pageString).concat(endOfUrlUrl)
                                        let pngUrlPdf = endUrlString.replace(/.pdf/, '.png')
                                        if (ele.verified === 'True') {
                                            ImageArray.push (
                                                <div className='image_list_divs_true'>
                                                    <h3>{ele.name}</h3>
                                                    <h4 className='labelsOnPhoto'>{ele.managerApprovedName}</h4>
                                                    <h4 className='labelsOnPhoto'>{ele.managerApprovedDate}</h4>
                                                    <img src={pngUrlPdf} loading="lazy" alt='cannot view' className='uploaded_image_two_true' onClick={(e, source) => handleMakingMainImage(e, pngUrlPdf, ele, id)}/>
                                                </div>
                                            )
                                        } else if (ele.verified === 'False') {
                                            ImageArray.push (
                                                <div className='image_list_divs_falseY'>
                                                    <h3>{ele.name}</h3>
                                                    <h4 className='labelsOnPhoto'>{ele.managerApprovedName}</h4>
                                                    <h4 className='labelsOnPhoto'>{ele.managerApprovedDate}</h4>
                                                    <img src={pngUrlPdf} loading="lazy" alt='cannot view' className='uploaded_image_two_true' onClick={(e, source) => handleMakingMainImage(e, pngUrlPdf, ele, id)}/>
                                                </div>
                                            )
                                        } else {
                                            ImageArray.push (
                                                <div className='image_list_divs_false'>
                                                    <h3>{ele.name}</h3>
                                                    <h4 className='labelsOnPhoto'>{ele.managerApprovedName}</h4>
                                                    <h4 className='labelsOnPhoto'>{ele.managerApprovedDate}</h4>
                                                    <img src={pngUrlPdf} loading="lazy" alt='cannot view' className='uploaded_image_two_false' onClick={(e, source) => handleMakingMainImage(e, pngUrlPdf, ele, id)}/>
                                                </div>
                                            )
                                        }
                                    }
                                } else {
                                    let pageString 
                                    let begginingOfUrl
                                    let endOfUrlUrl
                                    let endUrlString
                                    let pngUrlPdf
                                    // if (ele.name === 'Visa') {
                                    //     pageString = 'pg_1/'
                                    //     begginingOfUrl = ele.imagesLink.slice(0, 53)
                                    //     endOfUrlUrl = ele.imagesLink.slice(53)
                                    //     endUrlString = begginingOfUrl.concat(`w_200,h_250,c_fill,${pageString}`).concat(endOfUrlUrl)
                                    //     pngUrlPdf = endUrlString.replace(/.pdf/, '.png')
                                    // } else {
                                        pageString = 'pg_1/'
                                        begginingOfUrl = ele.imagesLink.slice(0, 53)
                                        endOfUrlUrl = ele.imagesLink.slice(53)
                                        endUrlString = begginingOfUrl.concat(pageString).concat(endOfUrlUrl)
                                        pngUrlPdf = endUrlString.replace(/.pdf/, '.png')
                                    // }
                                    if (ele.verified === 'True') {
                                        ImageArray.push (
                                            <div className='image_list_divs_true'>
                                                <h3>{ele.name}</h3>
                                                <h4 className='labelsOnPhoto'>{ele.managerApprovedName}</h4>
                                                <h4 className='labelsOnPhoto'>{ele.managerApprovedDate}</h4>
                                                <img src={pngUrlPdf} loading="lazy" alt='cannot view' className='uploaded_image_two_true' onClick={(e, source) => handleMakingMainImage(e, pngUrlPdf, ele, id)}/>
                                            </div>
                                        )
                                    } else if (ele.verified === 'False') {
                                        ImageArray.push (
                                            <div className='image_list_divs_falseY'>
                                                <h3>{ele.name}</h3>
                                                <h4 className='labelsOnPhoto'>{ele.managerApprovedName}</h4>
                                                <h4 className='labelsOnPhoto'>{ele.managerApprovedDate}</h4>
                                                <img src={pngUrlPdf} loading="lazy" alt='cannot view' className='uploaded_image_two_true' onClick={(e, source) => handleMakingMainImage(e, pngUrlPdf, ele, id)}/>
                                            </div>
                                        )
                                    } else {
                                        ImageArray.push (
                                            <div className='image_list_divs_false'>
                                                <h3>{ele.name}</h3>
                                                <h4 className='labelsOnPhoto'>{ele.managerApprovedName}</h4>
                                                {/* <h4 className='labelsOnPhoto'>{ele.managerApprovedDate}</h4> */}
                                                <img src={pngUrlPdf} loading="lazy" alt='cannot view' className='uploaded_image_two_false' onClick={(e, source) => handleMakingMainImage(e, pngUrlPdf, ele, id)}/>
                                            </div>
                                        )
                                    }
                                }
                            }
                        }
                    }
                })
                if (dvlaArray.length > 1) {
                    dvlaArray.sort((a, b) => (a.image_id > b.image_id ? 1 : -1))
                }
                let dvlaDoc = dvlaArray[dvlaArray.length - 1]
                if (dvlaDoc) {
                    localCounter++
                    if (!dvlaDoc.imagesLink.includes('.pdf')) {
                        if (dvlaDoc.verified === 'True') {
                            ImageArray.push (
                                <div className='image_list_divs_true'>
                                    <h3>{dvlaDoc.name}</h3>
                                    <h4 className='labelsOnPhoto'>{dvlaDoc.managerApprovedName}</h4>
                                    <h4 className='labelsOnPhoto'>{new Date(dvlaDoc.managerApprovedDate).toLocaleDateString('en-GB')}</h4>
                                    <img src={dvlaDoc.imagesLink} loading="lazy" alt='cannot view' className='uploaded_image_two_true' onClick={(e, source) => handleMakingMainImage(e, dvlaDoc.imagesLink, dvlaDoc, ImageArray.length)}/>
                                </div>
                            )
                        } else if (dvlaDoc.verified === 'False') {
                            ImageArray.push (
                                <div className='image_list_divs_falseY'>
                                    <h3>{dvlaDoc.name}</h3>
                                    <h4 className='labelsOnPhoto'>{dvlaDoc.managerApprovedName}</h4>
                                    <h4 className='labelsOnPhoto'>{new Date(dvlaDoc.managerApprovedDate).toLocaleDateString('en-GB')}</h4>
                                    <img src={dvlaDoc.imagesLink} loading="lazy" alt='cannot view' className='uploaded_image_two_true' onClick={(e, source) => handleMakingMainImage(e, dvlaDoc.imagesLink, dvlaDoc, ImageArray.length)}/>
                                </div>
                            )
                        } else {
                            ImageArray.push (
                                <div className='image_list_divs_false'>
                                    <h3>{dvlaDoc.name}</h3>
                                    <h4 className='labelsOnPhoto'>{dvlaDoc.managerApprovedName}</h4>
                                    {/* <h4 className='labelsOnPhoto'>{new Date(dvlaDoc.managerApprovedDate).toLocaleDateString('en-GB')}</h4> */}
                                    <img src={dvlaDoc.imagesLink} loading="lazy" alt='cannot view' className='uploaded_image_two_false' onClick={(e, source) => handleMakingMainImage(e, dvlaDoc.imagesLink, dvlaDoc, ImageArray.length)}/>
                                </div>
                            )
                        }
                    } else {
                        let pageString = 'pg_1/'
                        let begginingOfUrl = dvlaDoc.imagesLink.slice(0, 53)
                        let endOfUrlUrl = dvlaDoc.imagesLink.slice(53)
                        let endUrlString = begginingOfUrl.concat(pageString).concat(endOfUrlUrl)
                        let pngUrlPdf = endUrlString.replace(/.pdf/, '.png')
                        if (dvlaDoc.verified === 'True') {
                            ImageArray.push (
                                <div className='image_list_divs_true'>
                                    <h3>{dvlaDoc.name}</h3>
                                    <h4 className='labelsOnPhoto'>{dvlaDoc.managerApprovedName}</h4>
                                    <h4 className='labelsOnPhoto'>{dvlaDoc.managerApprovedDate}</h4>
                                    <img src={pngUrlPdf} loading="lazy" alt='cannot view' className='uploaded_image_two_true' onClick={(e, source) => handleMakingMainImage(e, pngUrlPdf, dvlaDoc, ImageArray.length)}/>
                                </div>
                            )
                        } else if (dvlaDoc.verified === 'False') {
                            ImageArray.push (
                                <div className='image_list_divs_falseY'>
                                    <h3>{dvlaDoc.name}</h3>
                                    <h4 className='labelsOnPhoto'>{dvlaDoc.managerApprovedName}</h4>
                                    <h4 className='labelsOnPhoto'>{dvlaDoc.managerApprovedDate}</h4>
                                    <img src={pngUrlPdf} loading="lazy" alt='cannot view' className='uploaded_image_two_true' onClick={(e, source) => handleMakingMainImage(e, pngUrlPdf, dvlaDoc, ImageArray.length)}/>
                                </div>
                            )
                        } else {
                            ImageArray.push (
                                <div className='image_list_divs_false'>
                                    <h3>{dvlaDoc.name}</h3>
                                    <h4 className='labelsOnPhoto'>{dvlaDoc.managerApprovedName}</h4>
                                    {/* <h4 className='labelsOnPhoto'>{dvlaDoc.managerApprovedDate}</h4> */}
                                    <img src={pngUrlPdf} loading="lazy" alt='cannot view' className='uploaded_image_two_false' onClick={(e, source) => handleMakingMainImage(e, pngUrlPdf, dvlaDoc, ImageArray.length)}/>
                                </div>
                            )
                        }
                    }
                }
            } else {
                let localImageNonManagerArray = []
                props.selectedDriver.imgArray.forEach( element => {
                    localImageNonManagerArray.push(
                        <h3>{element.name}</h3>
                    )
                })
                ImageArray.push(
                    <div className='nonManagerList'>
                        {localImageNonManagerArray}
                    </div>
                )
            }
            
            let sortArray = {
                'DVLA Check': 1,
                'Driving licence Front': 2,
                'Driving licence Back': 3 ,
                'POA': 4 ,
                'NIN': 5 ,
                'D&A test': 6 ,
                'Passport': 7 ,
                'ID': 8 ,
                'ID Back': 9 ,
                'BGC': 10 ,
                'Photo': 11 ,
                'Bank Details': 12 ,
                'Birth Certificate': 13 ,
                'Visa': 14 ,
                'UTR': 15 ,
                'VAT': 16 ,
                'Motor Insurance': 17 ,
                'G.I.T. Insurance': 18 ,
                'P.L. Insurance': 19 ,
                'TAX': 20 ,
                'MOT': 21 ,
                'V5': 22 ,
                'Rental': 23 ,
                'Return': 24 ,
                'Application Package': 25 ,
                'Other': 26 ,
            }

            // make a pointer to the array
            let localImageArray = ImageArray.sort((a, b) => (sortArray[a.props.children[0].props.children] > sortArray[b.props.children[0].props.children] ? 1 : -1))

            setNumberOfDocuments(localCounter)
            setImageArray(localImageArray)
        } else {
            setImageArray([])
        }
    }, [props.selectedDriver, props.renderVar])
    // after the highlighted image screen get the normal divs back 
    const getDivsBack = () => {
        setCurrentPageNumber(1)
        setHighlightedPicture(null)
        setHighlitedImageDetails(null)
        setHighlightedPictureGate(false)
        props.reRender(props.selectedDriver)
    }

    const addToOldList = (e, highlightedInformation) => {
        async function putData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };

        if (highlightedImageDetails.name === 'VAT') {
            putData(`https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`, {
                vat: false
            })
        } 

        putData(`https://backendpajamas.herokuapp.com/images/${highlightedImageDetails.image_id}/`, {
            storageBool: true,
        }).then( response => {
            getDivsBack()
        })
    }
    
    // verification process  ** TODO: add error screen explaining why verification didn't happen
    const getDivsBackAndVerify = (e, highlightedInformation) => {
        if (props.superUser || props.email === "compliance@h2ologistics.co.uk" || props.email === "compliance@h2ologistics.co.uk" || props.email === "Compliance@h2ologistics.co.uk" || props.email === "Compliance@h2ologistics.co.uk") {
            setCurrentPageNumber(1)
            setHighlightedPictureGate(false)
            let theDate = new Date()
            async function putData(url = '', data = {}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'PUT', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                    });
    
                return response ? response.json() : console.log('no reponse')
            };
            async function postData(url = '', data = {}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'POST', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                    });
    
                return response ? response.json() : console.log('no reponse')
            };
            async function getData(url = '') {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'GET', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    });
    
                return response ? response.json() : console.log('no reponse')
            };
            
            putData(`https://backendpajamas.herokuapp.com/images/${highlightedImageDetails.image_id}/`, {
                verified: 'True',
                managerApprovedName: props.userName,
                managerApprovedDate: theDate.toDateString(),
                driver_id: `https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`
            }).then( response => {
                returnToImageArrayLocal(response)
                postData(`https://backendpajamas.herokuapp.com/driverimages/`, {
                    "driver_id": props.selectedDriver.driver_id
                }).then( response => {
                    let localVar = 0
                    response.data.forEach( image => {
                        if (image.verified === "True") {
                            localVar++
                        }
                    })
                    if (localVar === response.data.length) {
                        putData(`https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`, {
                            status: 'verified'
                        })
                    }
                    else {
                        putData(`https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`, {
                            status: null
                        })
                    }
                })
            })
            setHighlitedImageDetails(null)
            setHighlightedPicture(null)
        }
    }

    const getDivsBackAndVerifyFalse = (e) => {
        if (props.superUser || props.email === "compliance@h2ologistics.co.uk" || props.email === "compliance@h2ologistics.co.uk" || props.email === "Compliance@h2ologistics.co.uk" || props.email === "Compliance@h2ologistics.co.uk") {
            setCurrentPageNumber(1)
            setHighlightedPictureGate(false)
            async function postData(url = '', data = {}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'PUT', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                    });
    
                return response ? response.json() : console.log('no reponse')
            };
            
            postData(`https://backendpajamas.herokuapp.com/images/${highlightedImageDetails.image_id}/`, {
                verified: 'False',
                managerApprovedName: props.userName,
                driver_id: `https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`
            }).then( response => {
                returnToImageArrayLocal(response)
            })
            setHighlitedImageDetails(null)
            setHighlightedPicture(null)
        }
    }

    const getDivsBackAndDelete = (e) => {
        if (props.superUser || props.email === "compliance@h2ologistics.co.uk" || props.email === "compliance@h2ologistics.co.uk" || props.email === "Compliance@h2ologistics.co.uk" || props.email === "Compliance@h2ologistics.co.uk") {
            async function putData(url = '', data = {}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'PUT', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                    });

                return response ? response.json() : console.log('no reponse')
            };
            let localNum = highlightedImageDetails
            setHighlightedPictureGate(false)
            setCurrentPageNumber(1)

            async function deleteData(url = '', data = {}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'DELETE', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    }
                });
                return response ? response : console.log('no reponse')
            };
            if (highlightedImageDetails.name === 'VAT') {
                putData(`https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`, {
                    vat: false
                })
            }
            async function postData(url = '', data = {}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'POST', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                    });

                return response ? response.json() : console.log('no reponse')
            };
            deleteData(`https://backendpajamas.herokuapp.com/images/${highlightedImageDetails.image_id}/`).then( response => {
                postData('https://backendpajamas.herokuapp.com/driverimages/', {
                    "driver_id": props.selectedDriver.driver_id
                }).then( responseImages => {
                    let isDriverVereified = false
                    if (responseImages.data) {
                        responseImages.data.forEach( image => {
                            if (image.verified !== 'verified') {
                                isDriverVereified = true
                            }
                        })
                        if (isDriverVereified) {
                            putData(`https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`, {
                                status: "verified"
                            })
                        }
                    }
                    props.reRender(props.selectedDriver)
                })
            })
            returnToImageArrayDelete(localNum)
            setHighlitedImageDetails(null)
            setHighlightedPicture(null)
        }
    }

    // verify button
    var verifyButton 
    var rejectButton
    if (highlightedPicture) {
        if (highlightedImageDetails.verified !== ('True' || 'False')) {
            verifyButton = (
                <div className="btn_picture" onClick={(e, targetImage) => getDivsBackAndVerify(e, highlightedPicture)}>
                    <svg width="125" height="45">
                    <defs>
                        <linearGradient id="grad1">
                            <stop offset="0%" stopColor="#F3F6F6"/>
                            <stop offset="100%" stopColor="#F3F6F6" />
                        </linearGradient>
                    </defs>
                    <rect x="5" y="5" rx="25" fill="none" stroke="url(#grad1)" width="115" height="35"></rect>
                    </svg>
                    <span className='span_in_Button'>Verify</span>  
                </div>  
            )
            rejectButton = (
                <div className="btn_picture" onClick={(e, targetImage) => getDivsBackAndVerifyFalse(e, highlightedPicture)}>
                    <svg width="125" height="45">
                    <defs>
                        <linearGradient id="grad1">
                            <stop offset="0%" stopColor="#F3F6F6"/>
                            <stop offset="100%" stopColor="#F3F6F6" />
                        </linearGradient>
                    </defs>
                    <rect x="5" y="5" rx="25" fill="none" stroke="url(#grad1)" width="115" height="35"></rect>
                    </svg>
                    <span className='span_in_Button'>Reject</span>  
                </div>  
            )
        }
    }

    // render the add driver component
    const addDriverRender = () => {
        setAddImageSelected(true)
    }

    // rerender images
    useEffect( () => {
        setAddImageSelected(false)
    }, [props.selectedDriver])

    // function to get rid off add documents screen
    const returnToImageArray = (imageArrayLocal) => {
        let driver = props.selectedDriver
        driver.imgArray = imageArrayLocal
        props.reRender(driver)
        setAddImageSelected(false)
    }

    // function to get rid off add documents screen
    const returnToImageArrayLocal = (verifiedImage) => {
        let newDriver = props.selectedDriver
        let localArray = props.selectedDriver.imgArray
        localArray.forEach( (image, imageId) => {
            if (image.image_id === verifiedImage.image_id) {
                localArray[imageId] = verifiedImage
            }
        })
        newDriver.imgArray = localArray
        props.reRender(newDriver)
        setAddImageSelected(false)
    }

    // function to get rid off add documents screen
    const returnToImageArrayDelete = (verifiedImage) => {
        let finalArray = []
        if (props.selectedDriver.imgArray.length > 1) {
            props.selectedDriver.imgArray.forEach( ele => {
                if (ele.image_id !== verifiedImage.image_id) {
                    finalArray.push(ele)
                }
            })
        }
        let newDriver = props.selectedDriver
        newDriver.imgArray = finalArray
        props.reRender(newDriver)
        setAddImageSelected(false)
    }

    // handle changing to page to one back
    const handleChangePageBack = (e) => {
        e.preventDefault()
            if (!handlePdfUrl.includes('w_200')) {
            let currentUrl = handlePdfUrl
            let newUrl = handlePdfUrl.match(/\/pg_[\d]+\//)
            let pageNumber = parseInt(newUrl[0].match(/\d+/))
            let newPageNumber = 1
            if (pageNumber > 1) {
                newPageNumber = pageNumber-1
            } 
            setCurrentPageNumber(newPageNumber)
            let finalUrl = currentUrl.replace(/\/pg_[\d]+\//, `/pg_${newPageNumber}/`)
            setHandlePdfUrl(finalUrl)
            setHighlightedPicture(
                <GoogleZoom
                    img={finalUrl}
                />
                )
        }
        // <img src={finalUrl} alt='cannot view' className='big_picture'/>
    }

    // handle allowing for download
    const handleDownload = (e) => {
        e.preventDefault()
        let currentUrl = handlePdfUrl
        let newUrl = handlePdfUrl.replace(/\/pg_[\d]+/, '')
        let finalUrl = newUrl.replace(/.png/, '.pdf')
        window.open(finalUrl, '_blank')
    }

    // useEffect to render the number changes
    useEffect( () => {
        if (percentGate) {
            setLoadingScreen(
                <div className='sizeErrorTwo'>
                    <h3>Loading next page....</h3>
                    <div class="meter">
                        <span className='insideNumbers'>{localPercent}</span>
                        <span className='barStyle'>
                        </span>
                    </div>
                </div>
            )
        }
    }, [localPercent, percentGate] )

    // handle changing th epage forward
    const handleChangePageForward = (e) => {
        e.preventDefault()
        if (!handlePdfUrl.includes('w_200')) {
            let currentUrl = handlePdfUrl
            let newUrl = handlePdfUrl.match(/\/pg_[\d]+\//)
            let pageNumber = parseInt(newUrl[0].match(/\d+/))
            let newPageNumber = 1
            if (pageNumber >= 1) {
                newPageNumber = pageNumber+1
            } 
            async function getData(url = '') {
                setPercentGate(true)
                let myInterval = setInterval( () => {
                    setLocalPercent('loading')
                }, 700)
                // myInterval()
    
                let responseFinal = null
                await fetch(url).then( response => {
                    setTimeout(() => {
                        clearInterval(myInterval)
                    }, 7000);
                    responseFinal = response
                })
    
                return responseFinal
            };
            let finalUrl = currentUrl.replace(/\/pg_[\d]+\//, `/pg_${newPageNumber}/`)
            getData(finalUrl).then( response => {
                if (response.status === 200) {
                    numberKeeper = 0
                    setPercentGate(false)
                    setLoadingScreen(null)
                    setCurrentPageNumber(newPageNumber)
                    setHandlePdfUrl(finalUrl)
                    setHighlightedPicture(
                        <GoogleZoom
                            img={finalUrl}
                        />
                        // <img src={} alt='cannot view' className='big_picture'/>
                    )
                }
                if (response.status === 400) {
                    setPercentGate(false)
                    setLoadingScreen(
                        <div className='sizeErrorTwo'>
                            <h3>No More Pages</h3>
                            <div class="meter">
                                {/* <span className='insideNumbers'>{localPercent}</span>
                                <span className='barStyle'>
                                </span> */}
                            </div>
                        </div>
                    )
                    setTimeout( () => {
                        setLoadingScreen(null)
                    }, 2000)
                }
            })
        }
    }

    // add the embed component
    const handleEmbed = (e) => {
        quickViewBool ? setQuickViewBool(false) : setQuickViewBool(true)
    }

    useEffect( () => {
        if (addImageSelected && !highlightedPictureGate) {
            setContent(
                <FormsDocuments 
                    selectedDriver={props.selectedDriver}
                    superUser={props.superUser ? true : false}
                    station={props.station}
                    fromDocument={true}
                    returnMe={returnToImageArray}
                    userName={props.user_name}
                    email={props.email}
                />
            )
        } else if (!addImageSelected && !highlightedPictureGate) {
            setContent(
                <div className='submit_files_two'> 
                    <div className='driverDocsTitle'>
                        <h2>{props.selectedDriver.name} | {numberOfDocuments} Documents</h2>
                    </div>
                    <div className="contentContainer">
                        <div className="leftButtons">
                            <button className='compliance_add_driver_button_submit' onClick={addDriverRender}>
                                <span className='span_in_complaince_button'>Add</span> 
                            </button>
                            <DriverHistory 
                                selectedDriver={selectedDriver}
                            />
                            <DvlaHistory
                                selectedDriver={selectedDriver}
                            />
                            <OldDocuments
                                selectedDriver={selectedDriver}
                                reRender={getDivsBack}
                                superUser={props.superUser}
                                user_email={props.email}
                            />
                        </div>
                        <div className="imageListContainer">
                            {imageArray}
                        </div>
                    </div>
                </div>  
            )
        } else if (highlightedPictureGate) {
            if (highlightedPicture) {
                var pageTurner = null
                var quickView = null
                if (highlightedImageDetails.imagesLink.includes('.pdf')) {
                    pageTurner = (
                        <>
                            <div className='pageTurner'>
                                <div className='pageNumber'>{currentPageNumber}</div>
                                <div className='pageTurnConatiner'>
                                    <div className='backPage' onClick={(e) => handleChangePageBack(e)}>
                                        <img src={triangle} alt="triangle" className='triangleBack' />
                                    </div>
                                    <div className='ForwardsPage' onClick={(e) => handleChangePageForward(e)}>
                                        <img src={triangle} alt="triangle" className='triangleForward' />
                                    </div>
                                </div>
                            </div>
                            <div className='pageTurnerTwo' onClick={handleDownload}>
                                <h3>Download</h3>
                            </div>
                        </>
                    )
                    quickView = (
                        <div className='quickView' onClick={(e) => handleEmbed(e)}>
                            <h3>Quick View</h3>
                        </div>
                    )
                }
                const returnDate = (theDate) => {
                    if (new Date(theDate).toLocaleDateString('en-GB') === '1/3/2030') {
                        return 'n/a'
                    } else if (new Date(theDate).toLocaleDateString('en-GB') === '01/03/2030') {
                        return 'n/a'
                    } else if (new Date(theDate).toLocaleDateString('en-GB') === '03/01/2030') {
                        return 'n/a'
                    } else if (new Date(theDate).toLocaleDateString('en-GB') === '3/1/2030') {
                        return 'n/a'
                    } else {
                        return new Date(theDate).toLocaleDateString('en-GB')
                    }
                }
                const returnDataHere = () => {
                    if (props.superUser || props.email === "compliance@h2ologistics.co.uk" || props.email === "compliance@h2ologistics.co.uk" || props.email === "Compliance@h2ologistics.co.uk" || props.email === "Compliance@h2ologistics.co.uk") {
                        return (
                            <div className="btn_picture" onClick={(e, targetImage) => addToOldList(e, highlightedPicture)}>
                            <svg width="125" height="45">
                            <defs>
                                <linearGradient id="grad1">
                                    <stop offset="0%" stopColor="#F3F6F6"/>
                                    <stop offset="100%" stopColor="#F3F6F6" />
                                </linearGradient>
                            </defs>
                            <rect x="5" y="5" rx="25" fill="none" stroke="url(#grad1)" width="115" height="35"></rect>
                            </svg>
                            <span className='span_in_Button'>Store</span>  
                        </div>  
                        )
                    }
                }
                setContent(
                    <div className='big_picture_div'>
                        <div className='button_div_box_top'>
                            <div>
                                <h3>
                                    Driver: {props.selectedDriver.name}
                                </h3>
                                <h3>
                                    Document: {highlightedImageDetails.name}
                                </h3>
                                <h3>
                                    Verified: {highlightedImageDetails.verified ? highlightedImageDetails.verified : 'Pending'}
                                </h3>
                                <h3>
                                    Expiry Date: {returnDate(highlightedImageDetails.expiryDate)}
                                </h3>
                            </div>
                        </div>
                            <div className='zoomBox'>
                                {loadingScreen}
                                {pageTurner}
                                {quickView}
                                {quickViewBool ? <Embeded url={handlePdfUrl}/>: highlightedPicture}
                            </div>
                        <div className='button_div_box'>
                            <div className="btn_picture" onClick={getDivsBack}>
                                <svg width="125" height="45">
                                <defs>
                                    <linearGradient id="grad1">
                                        <stop offset="0%" stopColor="#F3F6F6"/>
                                        <stop offset="100%" stopColor="#F3F6F6" />
                                    </linearGradient>
                                </defs>
                                <rect x="5" y="5" rx="25" fill="none" stroke="url(#grad1)" width="115" height="35"></rect>
                                </svg>
                                <span className='span_in_Button'>Return</span>  
                            </div>   
                            {returnDataHere()}
                            {verifyButton}
                            {rejectButton}
                            <div className="btn_picture" onClick={(e, targetImage) => getDivsBackAndDelete(e, highlightedPicture)}>
                                <svg width="125" height="45">
                                <defs>
                                    <linearGradient id="grad1">
                                        <stop offset="0%" stopColor="#F3F6F6"/>
                                        <stop offset="100%" stopColor="#F3F6F6" />
                                    </linearGradient>
                                </defs>
                                <rect x="5" y="5" rx="25" fill="none" stroke="url(#grad1)" width="115" height="35"></rect>
                                </svg>
                                <span className='span_in_Button'>Delete</span>  
                            </div>  
                        </div>
                    </div>
                )
            } else {
                setContent(
                    <div>
                        <h3>Loading</h3>
                    </div>
                )
            }
        }
    }, [addImageSelected, highlightedPictureGate, props.selectedDriver, highlightedImageDetails, currentPageNumber, loadingScreen, imageArray, selectedDriver, quickViewBool])

    return (
        <>
            {content}
        </>
    )
}

export default Documents